import { stripDisplayArtifacts } from './articleMarkdown'

/** Produktnavn/titler til UI (matcher backend sanitize_product_name). */
export function cleanProductLabel(text) {
  if (!text) return ''
  return stripDisplayArtifacts(String(text).trim())
}
